import DefaultCell from "application/components/DefaultCell";
import { agentReportMoreVert } from "globals/configuration/agentReportMoreVert";
import CTLClickToCall from "application/components/CTLClickToCall";
import { getCallCenterConfigurationReports } from "application/modules/configuration/callCenterConfiguration/component/allCallcenterRepots/reportMenu";

const callCenterConfigurationReports = getCallCenterConfigurationReports();
const getAttributesByRole = (agent) => {
  return {
    enableAddButton: false,
    enableUpdateTableRecords: agent ? false : true,
    enableAdvanceSearch: true,
    enableDownloadButton: true,
    enableDownloadPdf: agent ? false : true,
    enableRefresh: true,
    enableExitButton: agent ? true : false,
    modes: agent
      ? agentReportMoreVert.map((item) => {
          return {
            id: item.key,
            name: item.name,
            iconName: item.icon,
            url: item.url,
            description: item.description,
          };
        })
      : callCenterConfigurationReports.map((item) => {
          return {
            id: item.key,
            name: item.name,
            iconName: item.icon,
            url: item.url,
            description: item.description,
          };
        }),
  };
};

const operationURLS = {
  list: "/callbackReport/list",
  pdfDownload: "/callbackReport/generateAndDownloadPdf",
  csvDownload: "/callbackReport/downloadCSV",
};

const getColumns = (onCall, agent) => {
  return [
    {
      Header: "caller Id",
      accessor: "callerId",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) =>
        agent ? (
          <CTLClickToCall value={value} row={row} onCall={onCall} />
        ) : (
          <DefaultCell value={value} />
        ),
    },
    {
      Header: "callback Activated On",
      accessor: "callbackActivatedOn",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "callback Scheduled On",
      accessor: "callbackScheduledOn",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Callback Activated By",
      accessor: "callbackActivatedBy",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Queue Name",
      accessor: "queueName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Queue",
      accessor: "queue",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    ,
    {
      Header: "Campaign",
      accessor: "campaign",
      displayInList: true,
      allowFilter: false,
      dataType: "string",

      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Campaign Name",
      accessor: "campaignName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Status",
      accessor: "status",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "CID Name",
      accessor: "cidName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, getAttributesByRole, operationURLS };
